import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type { IApiGetOrganizationResponseBody } from '../OrganizationsApi.types';
import { useApi } from '~/lib/api/useApi';
import { appQueryKeyFactory } from '../../Apps/hooks/useAppQuery';
import { appsQueryKeyFactory } from '../../Apps/hooks/useAppsQuery';
import { organizationQueryKeyFactory } from './useOrganizationQuery';
import { organizationsQueryKeyFactory } from './useOrganizationsQuery';

export type IUseOrganizationAttachAppMutationValues = {
  organizationId: string;
  appId: string;
};

export const useOrganizationAttachAppMutation = (): UseMutationResult<
  IApiGetOrganizationResponseBody,
  unknown,
  IUseOrganizationAttachAppMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) =>
      api.organizations.attachApp(values.organizationId, {
        appId: values.appId,
      }),
    onSuccess: async (updatedOrganization, values) => {
      await Promise.all(
        [
          { queryKey: organizationsQueryKeyFactory() },
          {
            queryKey: appQueryKeyFactory({
              appId: values.appId,
            }),
          },
          { queryKey: appsQueryKeyFactory() },
        ].map((filters) => queryClient.invalidateQueries(filters)),
      );

      queryClient.setQueryData(
        organizationQueryKeyFactory({
          organizationId: updatedOrganization._id,
        })!,
        updatedOrganization,
      );
    },
  });
};
